export default {
  healthy: "#79bac1",
  infected: "#f76a8c",
  recovered: "#75daad",
  dead: "#323232"
};
